import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'
// import InputSelectUI from '../../../widgets/form/InputSelectUI'
import MappingGroupCreateModalSF from './MappingGroupCreateModalSF'

const MappingGroupCreateModalUI = ({ context, successMsg, errorList, setErrorList,
  // sourceValue
  sourceValue, onSourceValueChange, sourceValueError, setSourceValueError,
  // superuser role
  mappedValue, mappedValueList, onMappedValueChange, mappedValueError,
  //
  // ignoreSpaces, onIgnoreSpacesChange, booleanList,
  // modes
  createMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Add keywords'
    buttonLabel='Add'
    cancelLabel='Cancel'
    isOpen={createMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='sourceValue' label='Keywords' maxLength={100}
      value={sourceValue} onChange={onSourceValueChange}
      error={sourceValueError} setError={setSourceValueError}
      autoFocus={true}
    />
    <InputTextSF name='mappedValue' label='Mapped Value' value={mappedValue}
      onChange={onMappedValueChange} error={mappedValueError}
    />
    {/* <InputSelectUI name='ignoreSpaces' label='Ignore spaces'
      value={ignoreSpaces} optionList={booleanList}
      onChange={onIgnoreSpacesChange}
    /> */}
  </ModalFormUI>

export default MappingGroupCreateModalUI
